"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForumSchema = exports.ForumAuthorSchema = void 0;
var zod_1 = require("zod");
exports.ForumAuthorSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    fullName: zod_1.z.string(),
    displayName: zod_1.z.string().optional(),
    updatedAt: zod_1.z.string(),
    image: zod_1.z.string().optional(),
    forumLogo: zod_1.z.string().optional(),
    role: zod_1.z.string().optional(),
    banned: zod_1.z.boolean().optional().default(false),
});
// Forum = Channel model
exports.ForumSchema = zod_1.z.object({
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
    views: zod_1.z.number(),
    replies: zod_1.z.number(),
    activity: zod_1.z.string(),
    participantCount: zod_1.z.number().default(0),
    read: zod_1.z.boolean().optional(),
    unreadTopics: zod_1.z.number().optional(),
    author: exports.ForumAuthorSchema.optional(),
    authorId: zod_1.z.string().optional(),
    needsHelpfulMark: zod_1.z.boolean().optional(),
    channelId: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    accessible: zod_1.z.boolean().optional(),
    placeholder: zod_1.z.boolean().optional(),
    topicCount: zod_1.z.number().optional(),
    closedAt: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).optional().nullable(),
});
//# sourceMappingURL=Forum.js.map